export default "__VITE_ASSET__3491decb__"